import { Timestamp } from 'firebase/firestore';
import { TransformedPost } from '../scraper';

export interface OnboardRecord {
  id: string;
  username: string;
  instagramUrl: string;
  status: OnboardStatus;
  createdAt: Timestamp;
  createdBy?: string;
  posts?: TransformedPost[];
  postCount?: number;
  shopId?: string;
  error?: string;
}

export type OnboardStatus = 'pending' | 'fetching' | 'ready' | 'importing' | 'done' | 'error';

export interface StatusConfig {
  bg: string;
  text: string;
  label: string;
  icon: 'clock' | 'spinner' | 'check-circle' | 'arrow-up' | 'check' | 'x-circle';
}

export const STATUS_CONFIG: Record<OnboardStatus, StatusConfig> = {
  pending:   { bg: 'bg-amber-100',  text: 'text-amber-800',  label: 'In Queue',     icon: 'clock' },
  fetching:  { bg: 'bg-blue-100',   text: 'text-blue-800',   label: 'Fetching',     icon: 'spinner' },
  ready:     { bg: 'bg-green-100',  text: 'text-green-800',  label: 'Ready',        icon: 'check-circle' },
  importing: { bg: 'bg-purple-100', text: 'text-purple-800', label: 'Importing',    icon: 'arrow-up' },
  done:      { bg: 'bg-gray-100',   text: 'text-gray-500',   label: 'Complete',     icon: 'check' },
  error:     { bg: 'bg-red-100',    text: 'text-red-700',    label: 'Error',        icon: 'x-circle' },
};

export const extractUsername = (input: string): string => {
  const trimmed = input.trim().replace(/^@/, '');
  const match = trimmed.match(/instagram\.com\/([^\/\?\s]+)/);
  if (match) return match[1];
  if (/^[a-zA-Z0-9._]+$/.test(trimmed)) return trimmed;
  return '';
};

export const timeAgo = (date: any): string => {
  if (!date) return '';
  const now = Date.now();
  const ts = typeof date?.toMillis === 'function' ? date.toMillis() : typeof date === 'number' ? date : new Date(date).getTime();
  if (isNaN(ts)) return '';
  const diffMs = now - ts;
  const secs = Math.floor(diffMs / 1000);
  if (secs < 10) return 'just now';
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
};
